<template>
    <div class="modal fade" :class="{show: showModal }" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" v-html="modal_title"></h5>
                <button type="button" class="close" :disabled="isSubmitting" data-dismiss="modal" aria-label="Close" @click="$emit('close')">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form id="update-user-form" @submit.prevent="updateUser" v-if="updateAccess">
                   <div class="form-group">
                       <label>Subscription Plan</label>
                        <div class="products">
                            <div class="form-check" v-for=" product in products" :key="product.id" >
                                <input  class="form-check-input" :id="product.id" type="checkbox" :value="product.metadata.group_access" v-model="group_access" @change="checkGroupAccess($event)" :disabled="isSubmitting">
                                <label class="form-check-label" :for="product.id">
                                {{ product.name }} (<b>{{ product.metadata.group_access }}</b>)
                                </label>
                            </div>
                        </div>
                       <div class="text-danger" v-html="access_error_message"></div>
                   </div>
               </form>

               <form id="add-payment-form" @submit.prevent="addPaymentTag" v-else-if="addPaymentType">
                   <div class="form-group">
                       <label>Payment Type</label>
                       <select class="form-control" :disabled="isSubmitting"  v-model="selected_type" required>
                           <option v-for="(type, i) in payment_type" :key="i" :value="type.id">{{ type.name}}</option>
                       </select>
                   </div>
               </form>

               <div v-else-if="notifyTrial">
                   <div class="text-center">
                       <button class="btn btn-lg rounded-pill btn-outline-dark" @click="notify(1)" :disabled="isSubmitting">10 Days Notification</button>
                       <button class="btn btn-lg rounded-pill btn-outline-dark" @click="notify(2)" :disabled="isSubmitting">Before Trial Expiration</button>
                   </div>
               </div>

               <form id="add-user-form" @submit.prevent="addUser" v-else>
                   <div class="form-group">
                       <label for="subscriber_email">Full Name</label>
                       <input type="text" class="form-control" v-model="subscriber_name" :disabled="isSubmitting" required>
                   </div>
                   <div class="form-group">
                       <label for="subscriber_email">Email Address</label>
                       <input type="hidden" name="_token" :value="csrf">
                       <input type="email" class="form-control" v-model="subscriber_email" :disabled="isSubmitting" required>
                       <span class="text-danger" v-html="error_message"></span>
                   </div>
                   <div class="form-group">
                        <div class="form-check" >
                            <input class="form-check-input" type="checkbox" id="notification" value="1" v-bind:true-value="1" v-bind:false-value="0" v-model="notification" :disabled="isSubmitting">
                            <label class="form-check-label" for="notification">
                                Send Welcome Email Notification?
                            </label>
                        </div>
                    </div>
<!--                   <div class="form-group">-->
<!--                       <label for="account_type">Account Type</label>-->
<!--                       <select class="form-control" :disabled="isSubmitting"  v-model="account_type">-->
<!--                           <option value="prospects">Prospects</option>-->
<!--                           <option value="client">Client</option>-->
<!--                       </select>-->
<!--
                     <div class="form-group" :class="{hide: !stripe_payment}">
                            <div ref="card"></div>
                    </div> -->

<!--                    <div class="form-group"  v-if="account_type != 'prospects'">-->
<!--                       <label>Payment Type</label>-->
<!--                       <select class="form-control" :disabled="isSubmitting"  v-model="selected_type">-->
<!--                           <option value="" selected>None</option>-->
<!--                           <option v-for="(type, i) in payment_type" :key="i" :value="type.id">{{ type.name}}</option>-->
<!--                       </select>-->
<!--                   </div>-->

                   <div class="form-group"  v-if="account_type != 'prospects'">
                       <label>Group Access</label>
                        <div class="products">
                            <div class="form-check" v-for=" product in products" :key="product.id" >
                                <input  class="form-check-input" :id="product.id" type="checkbox" :value="product.metadata.group_access" v-model="group_access" @change="checkGroupAccess($event)" :disabled="isSubmitting">
                                <label class="form-check-label" :for="product.id">
                                    {{ product.name }}
                                </label>
                            </div>
                        </div>
                       <div class="text-danger" v-html="group_access_error_message"></div>
                   </div>
                   <div class="text-danger mb-2" v-html="access_error_message"></div>
               </form>
            </div>
            <div class="modal-footer">
                <!-- update access button -->
                <button type="submit" class="btn btn-primary" :disabled="isSubmitting" form="update-user-form" v-html="this.btn_value" v-if="updateAccess"></button>

                <!-- add payment type button -->
                <button type="submit" class="btn btn-primary" :disabled="isSubmitting" form="add-payment-form" v-html="this.btn_value" v-else-if="addPaymentType"></button>

                <div v-else-if="notifyTrial">
                    <b v-html="this.btn_value"></b>
                </div>

                <!-- add account button -->
                <button type="submit" class="btn btn-primary" :disabled="isSubmitting" form="add-user-form" v-html="this.btn_value" v-else></button>



                <!-- modal close button -->
                <button @click="$emit('close')" data-dismiss="modal" :disabled="isSubmitting" class="btn btn-secondary">Close</button>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
export default {
    props: {
        data: {},
        showModal: Boolean,
        updateAccess:Boolean,
        addPaymentType: Boolean,
        notifyTrial: Boolean
    },
    data() {
       return {
           stripe_pk: process.env.MIX_STRIPE_PK,
           csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
           subscriber_name: "",
           subscriber_email: null,
           account_type: 'client',
           group_access: ["Trial"],
           old_group_access:[],
           access_error_message: "",
           products: [],
           plans: [],
           selected_product: null, // product id
           subscription_info: null,
           isSubmitting: false,
           payment_type: [],
           selected_type: "",
           error_message:"",
           group_access_error_message:"",
           btn_value: 'Register Account',
           modal_title: 'Register Account',
           notification: 1,
       }
    },
    methods: {
        checkGroupAccess(e) {
            this.access_error_message = "";
            if(e.target.checked == true ) {
                let last_access_added = e.target.value;
                // this.group_access = this.group_access.push(last_access_added);
                let total_access = this.group_access.length;
                let selected_product = this.getProductByGroupAccessID(last_access_added);

                this.access_error_message = "";
                if(total_access > 1) {
                    let scope = this.subscriptionScope(last_access_added);

                        let access_error_message_html = "";
                    if(scope.covered_to.length || scope.included_to.length) {
                        // e.target.checked = false;
                        e.target.checked = false
                        this.group_access = this.group_access.slice(0, -1);

                        if(scope.included_to.length) {
                            let list_li = "";
                            let vm = this;
                            scope.included_to.forEach( function(val) {
                                list_li += `<li>${(vm.getProductByGroupAccessID(val))[0].name}</li>`;
                            });
                            let list = `<ul>${list_li}</ul>`;
                            access_error_message_html = `You are attempting to select <b>${selected_product[0].name}</b>, which covers the following subscriptions: <br /> ${list}`
                        }

                        if(scope.covered_to.length) {
                            let list_li = "";
                            let vm = this;
                            scope.covered_to.forEach( function(val) {
                                list_li += `<li>${(vm.getProductByGroupAccessID(val))[0].name}</li>`;
                            });
                            let list = `<ul>${list_li}</ul>`;
                            access_error_message_html = `You are attempting to select <b>${selected_product[0].name}</b>, which is already covered by the following subscription: <br /> ${list}`
                        }
                        return this.access_error_message = access_error_message_html;
                    }
                }
            }
        },

        subscriptionScope(group_access) {

            const allnewsletters = ["submacronewsletters", "subappequity", "subappcredit"];
            const entireDB = ["subappusdb", "subappasiadb", "subappeuropedb", "subappafricadb"];
            const everythingUS = ["subappusdb", ...allnewsletters];
            const FAalpha = ["subfaalphapulse", "subqgvtop50"];
            const everything = ["subqgvtop50", ...allnewsletters, ...entireDB, ...FAalpha];

            let covered_to = [], included_to = [];

            switch (group_access) {
                case "submacronewsletters":
                case "subappequity":
                case "subappcredit":

                    if(this.group_access.includes("suballnewsletters"))
                        covered_to.push("suballnewsletters");

                    if(this.group_access.includes("suballusaccess"))
                        covered_to.push("suballusaccess");

                    if(this.group_access.includes("subappaccess"))
                        covered_to.push("subappaccess");

                break;

                case "subqgvtop50":
                    if(this.group_access.includes("everything"))
                        covered_to.push("everything");
                    if(this.group_access.includes("subfaalphapulse"))
                        covered_to.push("subfaalphapulse");
                break;

                case "subfaalphapulse":
                    if(this.group_access.includes("everything"))
                        covered_to.push("everything");
                    if(this.group_access.includes("subqgvtop50"))
                        covered_to.push("subqgvtop50");
                    break;

                case "subappusdb":

                    if(this.group_access.includes("subappentiredb"))
                        covered_to.push("subappentiredb");

                    if(this.group_access.includes("suballusaccess"))
                        covered_to.push("suballusaccess");

                    if(this.group_access.includes("subappaccess"))
                        covered_to.push("subappaccess");
                break;

                case "subappasiadb":
                case "subappeuropedb":
                case "subappafricadb":

                    if(this.group_access.includes("subappentiredb"))
                        covered_to.push("subappentiredb");

                    if(this.group_access.includes("subappaccess"))
                        covered_to.push("subappaccess");

                break;

                case "suballnewsletters":

                    if(this.group_access.includes("submacronewsletters"))
                        included_to.push("submacronewsletters");

                    if(this.group_access.includes("subappequity"))
                        included_to.push("subappequity");

                    if(this.group_access.includes("subappcredit"))
                        included_to.push("subappcredit");

                    if(this.group_access.includes("suballusaccess"))
                        included_to.push("suballusaccess");

                    if(this.group_access.includes("subappaccess"))
                        included_to.push("subappaccess");


                break;

                case "subappentiredb":

                    if(this.group_access.includes("subappusdb"))
                        included_to.push("subappusdb");

                    if(this.group_access.includes("subappasiadb"))
                        included_to.push("subappasiadb");

                    if(this.group_access.includes("subappeuropedb"))
                        included_to.push("subappeuropedb");

                    if(this.group_access.includes("subappafricadb"))
                        included_to.push("subappafricadb");

                    if(this.group_access.includes("subappaccess"))
                        included_to.push("subappaccess");

                break;

                case "suballusaccess":

                    if(this.group_access.includes("submacronewsletters"))
                        included_to.push("submacronewsletters");

                    if(this.group_access.includes("subappequity"))
                        included_to.push("subappequity");

                    if(this.group_access.includes("subappcredit"))
                        included_to.push("subappcredit");

                    if(this.group_access.includes("suballnewsletters"))
                        included_to.push("suballnewsletters");

                    if(this.group_access.includes("subappusdb"))
                        included_to.push("subappusdb");

                break;

                case "subappaccess":
                   this.group_access.forEach(function(val) {
                       if(val != "subappaccess")
                        included_to.push(val);
                   });

                break;

                default:  break;
            }

            let response = {
                "covered_to" : covered_to,
                "included_to" : included_to
            };
            return response;
        },

        defaultLabel() {
            let self = this;
            self.subscriber_name = "";
            self.subscriber_email = null;
            self.account_type = "prospects";
            self.btn_value = "Register Account";
            self.modal_title = "Register Account";
            self.$emit("close");
            self.isSubmitting = false;
            self.$emit("reloadUserTable");
            self.error_message = "";
            self.selected_type = "";
            self.notification = 1;
        },
        addUser() {
            let self = this;
            self.isSubmitting = true;
            self.btn_value = "Please wait...";
            let payment_id = this.account_type == 'client' ? this.selected_type : '';
            if(this.account_type == 'client' && this.group_access.length < 1) {
                self.btn_value = "Register Account";
                self.isSubmitting = false;
                self.group_access_error_message ="<b>Please Select Group Access</b>";
            }else {
                self.group_access_error_message ="";

                axios.post('/api/add-user', {
                    subscriber_name: this.subscriber_name,
                    subscriber_email: this.subscriber_email,
                    send_email: this.notification,
                    group_access: (this.account_type == "prospects") ? "Trial" : this.group_access.join(","),
                    payment_id: payment_id,
                })
                .then((response) => {
                    if(response.data == "error") {
                        self.btn_value = "Register Account";
                        self.isSubmitting = false;
                        self.error_message ="<b>Email is already in use</b>";
                    } else {
                        let msg = {
                            header: 'Successfully Added',
                            message:`<b>Fullname:</b> ${response.data.fullname}<br/>
                                    <b>Username:</b> ${response.data.username}<br/>
                                    <b>Password:</b> ${response.data.password}<br/>
                                    <b>Subscription Plan:</b> ${response.data.group_access}<br/>`,
                        };
                        self.group_access = [];
                        self.selected_type = "";
                        this.$emit("message", msg);
                    }

                }, (error) => {
                    console.log(error);
                });
            }


        },
        updateUser() {
            let self = this;
            self.isSubmitting = true;
            self.btn_value = "Please wait...";
            axios.post('/api/update-group-access', {
                subscriber_email: this.data.user_name,
                old_group_access: this.old_group_access.join(","),
                group_access: this.group_access.join(","),
            })
            .then((response) => {
                this.$nextTick(() => {
                    this.defaultLabel();
                });
            }, (error) => {
                console.log(error);
            });

        },

        addPaymentTag() {
            let self = this;
            self.isSubmitting = true;
            self.btn_value = "Please wait...";
            axios.post('/api/add-payment-type', {
                subscriber_email: this.data.user_name,
                payment_id: this.selected_type,
            })
            .then((response) => {
                this.$nextTick(() => {
                    this.defaultLabel();
                });
            }, (error) => {
                console.log(error);
            });
        },

        notify(type) {
            let datax = this.data;

            let confirmation = confirm(`Send a notification email for ${datax.user_name}?`);
            if(!confirmation) return false;
            this.isSubmitting = true;
            this.btn_value = "Please wait...";
            axios.post('/api/notify', {
                data: datax,
                type: type
            })
            .then((response) => {
                let data = response.data;
                this.$nextTick(() => {
                    let msg = {
                        header: 'Successfully',
                        message:data,
                        reload:false,
                    };
                    this.$emit("message", msg);
                    this.$emit("close");
                    this.isSubmitting = false;
                    this.btn_value = "Register Account";
                });
            }, (error) => {
                console.log(error);
            });
        },

        selectedProduct() {
            this.getPlansByProductID();
        },

        getProductByGroupAccessID(groupAccessID) {
            let products = Object.assign([], this.products);

            return  products.filter((val) => val.metadata.group_access.match(groupAccessID));
        },

        async getAllProducts() {
            try {
                const response = await axios.get('/api/products');
                this.products = response.data;

                let first_key = Object.keys(this.products)[0];
                this.group_access = String(this.products[first_key]["metadata"]["group_access"]).split(",");
            } catch (ex) {
                console.log("error");
                console.log(ex);
            }
        },
        async defaulFormValue() {
            try {
                await this.getAllProducts();
            } catch (ex) {
                console.log("error");
                console.log(ex);
            }

        },
        setExistingAccess(data) {
            this.modal_title = "Add Subscription Plan";
            this.btn_value = 'Update Account';
            this.group_access = data.group_access;
            this.old_group_access = data.group_access
        },
        setAddPaymentInfo(data) {
            this.modal_title = "Add Payment Type";
            this.btn_value = 'Add Payment Type';
        },
        setNotifyInfo() {
            this.modal_title = "Notification Options ";
            this.btn_value = "";
        },

        closeModal() {
            this.group_access = [];
            this.group_access.push('subqgvtop50');
            this.btn_value = 'Register Account';
            this.modal_title = "Register Account";
        },

        async getAllPaymentType() {
            try {
                const response = await axios.get('/api/payment-types');
                this.payment_type = response.data;
            } catch (ex) {
                console.log("error");
                console.log(ex);
            }
        },
    },
    mounted: function () {
        // let stripe = window.Stripe(this.stripe_pk),
        // elements = stripe.elements(),
        // card = elements.create('card', {
        //     hidePostalCode: true
        // });
        // card.mount(this.$refs.card);
        this.getAllPaymentType();
        this.defaulFormValue();
    }

}
</script>

<style lang="scss" scoped>
    .show {
        display: block !important;
    }
    .hide {
        display: none !important;
    }
    .products {
        overflow: auto;
        max-height: 150px;
    }
</style>
